import { IconWrapper } from '../runtime';
export default IconWrapper('tabletennis', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M31.45 16.96C34.2114 16.96 36.45 14.7214 36.45 11.96C36.45 9.19857 34.2114 6.95999 31.45 6.95999C28.6885 6.95999 26.45 9.19857 26.45 11.96C26.45 14.7214 28.6885 16.96 31.45 16.96Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2"
    }
  }), h("path", {
    "attrs": {
      "d": "M36 34L34 23L23 28L10 25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M4 41.03H44",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("circle", {
    "attrs": {
      "cx": "9",
      "cy": "25",
      "r": "5",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "6",
      "cy": "17",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("path", {
    "attrs": {
      "d": "M34 23L44 29L29 34",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});